export default __webpack_public_path__ + "static/media/cleanproNoVoucher.1f1e5e7b.png";